module.exports = __webpack_public_path__ + "static/media/Vfestim.e020a1ba.jpg";